/**
 * Function that returns the relative difference between two numbers in the form of a percentage value.
 * @example relDiff(1, 2) // => '-50%'
 * @param a Target number
 * @param b Number to compare to
 */
export function relDiff(a: number, b: number) {
  return 100 * ((a - b) / ((a + b) / 2));
}
